module.exports = __webpack_public_path__ + "img/ManagedService.80d158c.png";